/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import { useRouter } from 'next/router';

import type { ListPositionPages } from 'Stores/VehicleListPositionStore/VehicleListPositionStore';
import {
	useGetListPosition,
	useResetListPosition,
	useSetListPosition,
} from 'Stores/VehicleListPositionStore/VehicleListPositionStore';

const useVehicleListPosition = (isLoading: boolean, page: ListPositionPages): void => {
	const router = useRouter();
	const getListPosition = useGetListPosition();
	const setListPosition = useSetListPosition();
	const resetListPosition = useResetListPosition();

	const getCurrentListPosition = () => ({
		createdAt: Date.now(),
		listScrollPosition: window.scrollY,
	});

	const handleUpdateListPosition = useCallback(
		(url: string, { shallow }: { shallow: boolean }) => {
			if (!shallow) {
				const updatedListPosition = getCurrentListPosition();
				setListPosition(updatedListPosition, page);
			}
		},
		[setListPosition],
	);

	useEffect(() => {
		router.events.on('routeChangeStart', handleUpdateListPosition);
		return () => {
			router.events.off('routeChangeStart', handleUpdateListPosition);
		};
	}, [router, handleUpdateListPosition]);

	useEffect(() => {
		const listPosition = getListPosition(page);
		if (listPosition !== undefined && !isLoading) {
			requestAnimationFrame(() => {
				window.scrollTo(0, listPosition.listScrollPosition);
				resetListPosition();
			});
		}
	}, [getListPosition, isLoading]);
};

export default useVehicleListPosition;
